import axios from '@/http'
const api = process.env.VUE_APP_APIMATERIALS
const api2 = process.env.VUE_APP_APIUSER

let url = api
const reviewUrl = process.env.VUE_APP_REVIEW;
const apiHelp = {
  // 列表

  getContentList: async function () {
    return new Promise((resolve, reject) => {
      axios.get(url + '/api/content/list', {})
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取详情
  getContentDetails: async function (id) {
    return new Promise((resolve, reject) => {
      axios.get(url + '/api/content/' + id, {})
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getQuickLink: function () {
    return new Promise((resolve, reject) => {
      axios.get(reviewUrl + "/helpQuickLink/list")
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取是否关注
  userFocus: async (data) => {
    return new Promise(async (resolve, reject) => {
      axios.get(`${api2}/api/userFocus/${data.no}/${data.type}`).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 关注/取消关注
  attentionHandle: async (data) => {
    return new Promise(async (resolve, reject) => {
      axios.post(`${api2}/api/userFocus`, data).then(res => {
        resolve(res)
      })
        .catch(err => {
          reject(err)
        })
    })
  }
}
export default apiHelp
